import { render, staticRenderFns } from "./Matter.vue?vue&type=template&id=18c69d84&"
import script from "./Matter.vue?vue&type=script&lang=js&"
export * from "./Matter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports